import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileListTimeFill.tsx
const IconFileListTimeFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ jsx("path", { d: "M12.383 12.384h5.384v1.9h-5.384z" }),
			/* @__PURE__ */ jsx("path", { d: "M12.383 8.9h1.9v5.384h-1.9z" }),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M6.667 29.333h18.666a4 4 0 0 0 4-4V20H24V4c0-.736-.597-1.333-1.333-1.333H4c-.736 0-1.333.597-1.333 1.333v21.333a4 4 0 0 0 4 4m17.333-4v-2.666h2.667v2.666a1.333 1.333 0 1 1-2.667 0m-17-12a6.333 6.333 0 1 1 12.667 0 6.333 6.333 0 0 1-12.667 0m10.767-.95h-3.484V8.9h-1.9v5.384h5.384z",
				clipRule: "evenodd"
			})
		]
	})]
});
var IconFileListTimeFill_default = forwardRef(IconFileListTimeFill);
//#endregion
export { IconFileListTimeFill_default as default };
